import { render, staticRenderFns } from "./paymentsList.vue?vue&type=template&id=6fe2c066&scoped=true&"
import script from "./paymentsList.vue?vue&type=script&lang=js&"
export * from "./paymentsList.vue?vue&type=script&lang=js&"
import style0 from "./paymentsList.vue?vue&type=style&index=0&id=6fe2c066&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe2c066",
  null
  
)

export default component.exports